<template>
  <div>
    <v-layout row warp>
      <v-flex xs12 text-xs-right>
        <v-dialog
          v-model="openDialogChat"
          persistent
          scrollable
          max-width="500px"
        >
          <v-card>
            <v-toolbar>
              <v-icon large color="black">message</v-icon>
              <v-toolbar-title>
                <h3>WESERVE CHAT APPLICATION</h3>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn @click="closeDialogChat" icon>
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text
              style="height: 750px; background-color: #ffd600; overflow: hidden"
              v-if="isLoading == false"
            >
              <iframe
                v-if="chatProvider == 'weserve'"
                class="chat-log"
                :src="urlsEndcode"
                title="chat application"
              ></iframe>
              <iframe
                v-else-if="order_detail"
                class="chat-log"
                :src="
                  `https://sendbird.takeachat.com?order_code=${
                    order_detail.order_code
                  }&order_type=${
                    order_detail.order_type == 1 ? 'food' : 'messenger'
                  }&user_phone=${
                    order_detail.order_customer.customer_tel
                  }&user_full_name=${
                    order_detail.order_customer_full_name
                  }&customer_id=${order_detail.order_customer_id}`
                "
                title="chat application"
              ></iframe>
              <iframe
                v-else
                class="chat-log"
                :src="
                  `https://sendbird.takeachat.com?order_code=${
                    order_detail_message.order_code
                  }&order_type=${
                    order_detail_message.order_type == 1 ? 'food' : 'messenger'
                  }&user_phone=${
                    order_detail_message.order_customer_tel
                  }&user_full_name=${
                    order_detail_message.order_customer_full_name
                  }&customer_id=${order_detail_message.order_customer_id}`
                "
                title="chat application"
              ></iframe>
            </v-card-text>
            <v-casrd-text
              v-else
              style="
                height: 750px;
                background-color: #ffd600;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                width="100px"
                height="100px"
                class="img-animate"
                src="@/assets/Pos/user.png"
              />
            </v-casrd-text>
            <v-divider></v-divider>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: [
    "openDialogChat",
    "order_detail",
    "statusBtn",
    "order_detail_message",
    "provinceData",
  ],
  data() {
    return {
      params: "https://clients.takeachat.com/chatroom/",
      endCode: "",
      chatProvider: "weserve",
      isLoading: false,
    };
  },
  watch: {
    async openDialogChat(newValue, oldValue) {
      if (this.openDialogChat == true) {
        this.isLoading = true;
        let result = await this.getOrderChatSetting({
          province: this.$route.params.province,
        });

        this.isLoading = false;
        if (result === false) return;
        this.chatProvider = result;
      }
    },
  },
  computed: {
    urlsEndcode() {
      let province = this.provinceData.find((value) => {
        return (
          this.splitProvince(value.province_name_en)
            .toString()
            .toLowerCase() == this.$route.params.province
        );
      });
      if (province) {
        if (this.statusBtn == "order_detail") {
          this.endCode = btoa(
            `id=9999999&room=${this.order_detail.order_code}&provinceId=${
              province.province_id
            }&username=Admin&usertype=3&accesstoken=${localStorage.getItem(
              "token"
            )}`
          );
          console.log(`${this.params}${this.endCode}`);
          return `${this.params}${this.endCode}`;
        } else if (this.statusBtn == "oder_mess_detail") {
          this.endCode = btoa(
            `id=9999999&room=${
              this.order_detail_message.order_code
            }&provinceId=${
              province.province_id
            }&username=Admin&usertype=3&accesstoken=${localStorage.getItem(
              "token"
            )}`
          );
          console.log(`${this.params}${this.endCode}`);
          return `${this.params}${this.endCode}`;
        }
      }
    },
  },
  methods: {
    ...mapActions({
      getOrderChatSetting: "fetchOrderDetailBack/getOrderChatSetting",
    }),
    closeDialogChat() {
      this.$emit("toggleDialogChat", this.openDialogChat);
    },
    splitProvince(province) {
      let province_set = "";
      let province_split = province.split(" ");
      for (let val of province_split) {
        province_set += val;
      }
      return province_set;
    },
  },
};
</script>

<style scoped>
.chat-log {
  border: solid black 0px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 100%;
  height: 100%;
}
.header {
  background-color: white;
  color: black;
}

.img-animate {
  animation: lds-circle 5s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

@keyframes lds-circle {
  0%,
  100% {
    animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
  }
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(1800deg);
    animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
  }
  100% {
    transform: rotateY(3600deg);
  }
}
</style>
